module.exports = __webpack_public_path__ + "img/78.c1f890f7.png";